import { AnyAction } from "redux";
import {
  GET_SEARCH_RESULTS,
  SET_SEARCH_FILTERS,
  RESET_SEARCH_FILTERS,
  SET_SEARCH_MODE,
  // SET_POSITION
} from "../actions/search";
import { NamedReport } from "types/search";

const initialSearchState = {
  query: "",
  results: [],
  namedReports: [] as NamedReport[],
  filters: {
    sortBy: "new",
    category: "all",
    region: "all",
  },
  correctedQuery: null,
  suggestedQuery: null,
  mode: "exact" as "fuzzy" | "exact",
};

const searchReducer = (state = initialSearchState, action: AnyAction) => {
  switch (action.type) {
    case GET_SEARCH_RESULTS:
      return {
        query: action.payload.query,
        results: action.payload.results,
        namedReports: action.payload.namedReports,
        filters: {
          ...state.filters,
        },
        correctedQuery: action.payload.correctedQuery,
        suggestedQuery: action.payload.suggestedQuery,
        mode: state.mode,
      };
    case SET_SEARCH_MODE:
      return {
        ...state,
        mode: action.payload,
      };
    case SET_SEARCH_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.type]: action.payload.value,
        },
      };
    case RESET_SEARCH_FILTERS:
      return {
        ...state,
        filters: initialSearchState.filters,
      };
    // case SET_POSITION:
    //   return {
    //     ...state,
    //     position: action.payload.value,
    //   };
    default:
      return state;
  }
};

export default searchReducer;
